import { AuthenticatedTemplate } from '@azure/msal-react';
import ResponsiveDrawer from "../src/common/drawer";

export const PageLayout = (props) => {
    return (
        <>
            <AuthenticatedTemplate>
            <ResponsiveDrawer />
            </AuthenticatedTemplate>
            {props.children}
        </>
    );
};